import { WatcherFunction } from '..'
import { watchFetchShortlistSummary } from './fetch'

export const shortlistSummarySagas: ReadonlyArray<WatcherFunction> = [watchFetchShortlistSummary]
